import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import { radioLabelStylesSAG, radioLabelStylesSHS } from './radio-label.styles';

@Directive({
  selector: 'label[sag-ui-radio-label]',
})
export class RadioLabelDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const radioLabelStyles = componentStylesByTheme(
      this.theme,
      radioLabelStylesSAG,
      radioLabelStylesSHS
    );
    style(this.elementRef, radioLabelStyles());
  }
}
